export const DEFAULT_BRAND_NAME = "RentBhai";

export const BRAND_NAME =
  process.env.REACT_APP_BRAND_NAME?.trim() || DEFAULT_BRAND_NAME;

export const brandText = (template: string): string =>
  template.split(DEFAULT_BRAND_NAME).join(BRAND_NAME);
